export default {
    updateQueryParams({ commit }, queryParams) {
        commit('update', ['queryParams', queryParams]);
    },
};
